module.exports = __webpack_public_path__ + "static/communities-hero-desktop.26719dc6.webp";